import { Middleware } from 'redux';
import RootState from '../RootState';
import * as Actions from '../actions';
import SaveState from '../SaveState';

const handler: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    const hadNewChanges = (store.getState() as RootState).flyer.hasNewChanges;
    next(action);
    const flyerState = (store.getState() as RootState).flyer;
    const hasNewChanges = flyerState.hasNewChanges;
    if (
      !hadNewChanges &&
      hasNewChanges &&
      flyerState.saveStatus === SaveState.Saved
    ) {
      setTimeout(() => {
        store.dispatch({
          type: Actions.SAVE_STATE_CHANGED,
          state: SaveState.Unsaved
        });
      }, 1);
    }
  };

export default handler;



// WEBPACK FOOTER //
// ./src/state/side-effects/didChangeFlyer.ts